module.exports = __webpack_public_path__ + "media/goal_crusher_sweepstakes/goal-crusher-lock-up-a82cca2f.png";